import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/inflation-impact-calculator',
  component: () => import('../../routes/InflationImpactCalculator.svelte'),
  card: {
    id: 'inflation-impact',
    title: 'Inflation Impact Calculator',
    description: 'See how inflation erodes your purchasing power over time and what your money will really be worth in the future.',
    icon: 'trending_down',
    iconBgClass: 'bg-amber-50',
    iconTextClass: 'text-amber-600',
    href: '/inflation-impact-calculator',
    category: 'Retirement & Tax',
  },
  seo: {
    title: 'Inflation Impact Calculator — See How Inflation Erodes Your Purchasing Power',
    description: 'Calculate how inflation affects your money over time. See what $100 today will cost in 10 years and how much purchasing power you\'ll lose at different inflation rates.',
  },
};

export default meta;